<div class="row">
    <div *ngFor="let category of sortByTag(categories)">
        <app-category-button class="mx-1 mb-1" [categoryTag]="category.categoryTag"
            tooltipClass="tooltip-primary" matTooltip="{{category.fullName}}">
        </app-category-button>
    </div>
</div>
